import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FieldType, FormlyModule } from '@ngx-formly/core';

@Component({
    selector: 'toggle-input',
    template: ` <div [ngClass]="{ 'toggle-input': !to.clearClass }">
		<mat-slide-toggle color="primary" [formControl]="formControl" [formlyAttributes]="field" [labelPosition]="to.labelPosition || 'before'">
			{{ to.label }}
		</mat-slide-toggle>
	</div>`,
    styleUrls: ['./form.component.less'],
    standalone: true,
    imports: [
        NgClass,
        MatSlideToggleModule,
        FormsModule,
        ReactiveFormsModule,
        FormlyModule,
    ],
})
export class FormlyToggleInputComponent extends FieldType {}
